import moment from "moment";

export default function (value) {
  return moment.unix(value).format("DD/MM/YY");
}
